import {gsap} from "gsap";
import EmitEvent, {PAGE_LOADED} from "../../../libs/emit-event";
import {checkDeviceMobile} from "../../../libs/helper";

export class MenuItemHover {
    constructor({el, onClick}) {
        this.DOM = {el};
        this.onClick = onClick;
        this.createDom();
        this.bindEvent();
    }

    createDom() {

        const span = document.createElement('span');
        this.DOM.lineActive = document.createElement('span');

        span.classList.add('lineActive');
        this.DOM.lineActive.classList.add('lineActive_element');
        this.DOM.lineActiveClone = this.DOM.lineActive.cloneNode(true);
        this.DOM.lineActiveClone.classList.add('lineActive_element', 'is-clone');

        span.append(this.DOM.lineActive);
        span.append(this.DOM.lineActiveClone);
        this.DOM.el.append(span);

        gsap.set(this.DOM.lineActive, {x: "-105%"});
        gsap.set(this.DOM.lineActiveClone, {opacity: 0});
        this.isActive = this.DOM.el.parentElement.classList.contains('current-menu-item');
    }

    lineIn() {
        gsap.killTweensOf(this.DOM.lineActive);
        gsap.fromTo(this.DOM.lineActive, {x: '-105%', opacity: 1}, {x: '0%', ease: 'power3.out', duration: .4});
    }

    lineOut() {
        if (!this.isActive) return;
        gsap.killTweensOf(this.DOM.lineActive);
        gsap.set(this.DOM.lineActive, {x: '-105%'});
    }

    lineAnimationLeave() {
        gsap.killTweensOf([this.DOM.lineActiveClone, this.DOM.lineActive]);
        gsap.set(this.DOM.lineActive, {opacity: 0});
        gsap.fromTo(this.DOM.lineActiveClone, {x: '0%', opacity: 1}, {x: '105%', ease: 'power3.out', duration: .4});
    }

    onEnter() {
        if (this.isActive) return;
        this.lineIn();
    }

    onLeave() {
        if (this.isActive || this.DOM.el.parentElement.classList.contains('current-menu-item')) return;
        this.lineAnimationLeave();
    }

    pageEnter() {
        this.isActive = this.DOM.el.parentElement.classList.contains('current-menu-item');
        if (!this.isActive) {
            gsap.killTweensOf(this.DOM.lineActive);
            gsap.set(this.DOM.lineActive, {x: '-105%'});
        }
    }

    onMouseClick() {
        this.DOM.el.parentElement.classList.add('current-menu-item');
        gsap.set(this.DOM.lineActive, {x: '0%'});
        this.onClick();
    }

    bindEvent() {
        if (!checkDeviceMobile()) {
            this.DOM.el.addEventListener('mouseenter', this.onEnter.bind(this));
            this.DOM.el.addEventListener('mouseleave', this.onLeave.bind(this));
        }

        this.DOM.el.addEventListener('click', this.onMouseClick.bind(this));
        this.DOM.el.parentElement.addEventListener('animationIn', () => {
            if (this.isActive) this.lineIn();
        });

        EmitEvent.on(PAGE_LOADED, this.pageEnter.bind(this));
    }
}